import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { User } from '../models/user-model';
import { AuthService } from '../services/auth/auth.service';


@Injectable({ providedIn: 'root' })
export class LogoutGuard implements CanActivate {
    currentUser: any;
    constructor(
        private router: Router,
        private authenticationService: AuthService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.authenticationService.currentUser.subscribe((user) => {
            if (user) {
                this.router.navigate(["/dashboard"]);
            }
        });

        // not logged in 
        return true;
    }
}